@if (isLoadingState()) {
  <app-loading />
} @else {
  <div class="gap-4">
    <app-proposal-guidance-preview
      [projectId]="projectId"
      [isButtonDisabled]="isButtonDisabled()"
      (statusChange)="statusChange.emit($event)"
    ></app-proposal-guidance-preview>

    <app-trusted-text-preview
      textKey="step_rfq_guidance_proposal_preview_part_1"
    ></app-trusted-text-preview>

    <app-trusted-text-preview
      textKey="step_rfq_guidance_proposal_preview_part_2"
    ></app-trusted-text-preview>
    <br />

    <app-trusted-text-preview
      textKey="step_rfq_guidance_proposal_preview_part_3"
    ></app-trusted-text-preview>
    <br />

    <app-trusted-text-preview
      textKey="step_rfq_guidance_proposal_preview_part_4"
    ></app-trusted-text-preview>
    <br />

    <app-trusted-text-preview
      textKey="step_rfq_guidance_proposal_preview_part_5"
    ></app-trusted-text-preview>
  </div>
}
